import { UiSpacerModel } from "../../models";

export function mockUiSpacerModel({
    id = "spacer-1234",
    type = "uiSpacer",
    locale = "en",
    content = mockUiSpacerModelContent()
}: Partial<UiSpacerModel> = {}): UiSpacerModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiSpacerModelContent = UiSpacerModel["content"];

export function mockUiSpacerModelContent({
    entryTitle = "spacer-test",
    size = "1"
}: Partial<UiSpacerModelContent> = {}): UiSpacerModelContent {
    return {
        entryTitle,
        size
    };
}
